import { put, takeLatest, select } from "redux-saga/effects";
import {
  fetchSchemaRequest,
  fetchSchemaSuccess,
  fetchSchemaFailure,
} from "./schemaSlice";
import baseURL from "../../utils/config";

function* fetchSchemaSaga(action) {
  try {
    // Check if schema is already cached in state
    const state = yield select((state) => state.schema);
    if (state.schema) {
      // Schema already loaded, no need to fetch again
      return;
    }

    const response = yield fetch(`${baseURL}/cassandra/solutions_schema`, {
      method: "GET",
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = yield response.json();
    const schema = result.data || result;

    yield put(fetchSchemaSuccess(schema));
  } catch (error) {
    console.error("Error in fetchSchemaSaga:", error);
    yield put(fetchSchemaFailure(error.message));
  }
}

export function* watchSchemaSaga() {
  yield takeLatest(fetchSchemaRequest, fetchSchemaSaga);
}

